import Ports from '../../models/Ports';
import { RECEIVE_DESTINATION_PORTS } from '../actions/actionTypes';

const initialState: Ports = {}

export const destinationPortsReducer = (state: Ports = initialState, action: any) => {
  switch (action.type) {
    case RECEIVE_DESTINATION_PORTS:
      return {...action.data};
    default:
     return state
  }

};
